const TIMESTAMP_TIME = "8:30 pm ";
let TODAY = new Date();
var curr_date = ("0" + TODAY.getDate()).slice(-2);
var curr_month = ("0" + (TODAY.getMonth() + 1)).slice(-2); //Months are zero based
var curr_year = TODAY.getFullYear();

export const YESTERDAY =
  TIMESTAMP_TIME + new Date(TODAY.setDate(TODAY.getDate() - 1)).toDateString();

export const ActiveDate = curr_year + "-" + curr_month + "-" + curr_date;

export const TAB_MAP_ID = {
  // LEAVING_UAE: 'FROMUAE',
  // RETURNING_TO_UAE: 'TOUAE',
  TRAVEL_INFO: "TRAVEL_INFORMATION",
  VISA_FAQ: "VISAUAE",
  STAYCATIONS: "STAYCATIONS",
  PODCASTS: "PODCASTS",
};

export const COM_TAB_MAP_ID = {
  DOM_TRAVEL: "DOM",
  INT_TRAVEL: "INT",
};

export const ROUTE_MAP_ID = {
  ARE_IND: "ARE_IND",
  IND_CAN: "IND_CAN",
  IND_GER: "IND_GER",
  IND_UK: "IND_UK",
  IND_USA: "IND_USA",
  IND_MDV: "IND_MDV",
  ARE_PAK: "ARE_PAK",
  ARE_PHL: "ARE_PHL",
  ARE_EGY: "ARE_EGY",
  IND_ARE: "IND_ARE",
  IND_UAE: "IND_UAE",
  UAE_IND: "UAE_IND",
  IND_UAE: "IND_ARE",
  UAE_IND: "ARE_IND",
  IND_CAN: "IND_CAN",
  IND_GER: "IND_GER",
  IND_UK: "IND_GBR",
  IND_USA: "IND_USA",
  SAU_EGY: "SAU_EGY",
  SAU_ARE: "SAU_ARE",
  SAU_IND: "SAU_IND",
  SAU_PHL: "SAU_PHL",
  SAU_PAK: "SAU_PAK",
  SAU_KWT: "SAU_KWT",
  ARE_SAU: "ARE_SAU",
  ARE_JOR: "ARE_JOR",
  ARE_LBN: "ARE_LBN",
  ARE_BHR: "ARE_BHR",
  ARE_MDV: "ARE_MDV",
  ARE_SYC: "ARE_SYC",
  ARE_TUR: "ARE_TUR",
  ARE_GRC: "ARE_GRC",
  ARE_CYP: "ARE_CYP",
  ARE_RUS: "ARE_RUS",
  ARE_ITA: "ARE_ITA",
  ARE_ESP: "ARE_ESP",
  ARE_FRA: "ARE_FRA",
  ARE_THA: "ARE_THA",
  ARE_GEO: "ARE_GEO",
  ARE_ARM: "ARE_ARM",
  ARE_SRB: "ARE_SRB",
  ARE_CHE: "ARE_CHE" 
};

export const CATEGORY_MAP = {
  NO_ENTRY: "NO_ENTRY",
  NO_EXIT: "NO_EXIT",
  RESTRICTED_ENTRY: "RESTRICTED_ENTRY",
  RESTRICTED_EXIT: "RESTRICTED_EXIT",
  ENTRY: "ENTRY",
  EXIT: "EXIT",
  BOARDING: "BOARDING",
  TRANSIT: "TRANSIT",
  QUARANTINE: "QUARANTINE",
  DOC_REQUIRED: "DOC_REQUIRED",
  PPE: "PPE",
  HEALTH_ASSESSMENT: "HEALTH_ASSESSMENT",
  HEALTH_MEASURES: "HEALTH_MEASURES",
  SANITIZATION: "SANITIZATION",
  RE_ENTRY_PERMIT: "RE_ENTRY_PERMIT",
  DEPOSIT_REQUIRED: "DEPOSIT_REQUIRED",
  VISA: "VISA",
  DEFAULT: "DEFAULT",
  TRANSIT: "TRANSIT",
  QUARANTINE: "QUARANTINE",
  DOC_REQUIRED: "DOC_REQUIRED",
  PPE: "PPE",
  HEALTH_ASSESSMENT: "HEALTH_ASSESSMENT",
  HEALTH_MEASURES: "HEALTH_MEASURES",
  SANITIZATION: "SANITIZATION",
  RE_ENTRY_PERMIT: "RE_ENTRY_PERMIT",
  DEPOSIT_REQUIRED: "DEPOSIT_REQUIRED",
  VISA: "VISA",
  DEFAULT: "DEFAULT",
};

export const LINK_MAP = {
  DEFAULT: 'DEFAULT',
  DOWNLOAD: 'DOWNLOAD',
  LINK: 'LINK',
};

export const TEST_TYPES = {
  'PCR_TEST': 'PCR Test',
  'NUCLEIC_ACID_TEST': 'Nucleic Acid Test',
  'LAMP_TEST': 'LAMP Test',
  'ANTIGEN_TEST': 'Antigen Test',
  'RT_PCR_TEST': 'RT-PCR Test',
  'TMA_TEST': 'TMA Test',
  'RT_LAMP_TEST': 'RT-LAMP Test',
}

export const CONDITION = {
  'BEFORE_DEPARTURE': 'Before Departure',
  'BEFORE_FINAL_BOARDING': 'Before Final Boarding',
  'BEFORE_ARRIVAL': 'Before Arrival',
}

export const PROD_API_KEY = "AIzaSyBk_-r3WvD9eO4Zsh0gr0--_vRmoKpcncc";
export const SANDBOX_API_KEY = "AIzaSyDszSC_QbiEjxZU1-Au1JRDF4yOPqv_5jM";
export const DOMAIN_COUNTRY_MAP = {
  'http://localhost:3031': 'SA',
  'http://localhost:3000': 'SA',
  'https://qa2.cleartrip.com': 'IN',
  'https://qa2new.cleartrip.com': 'IN',
  'https://airdev.cleartrip.com': 'IN',
  'https://qa2new.cleartrip.ae': 'AE',
  'https://www.cleartrip.com': 'IN',
  'https://om.cleartrip.com': 'OM',
  'https://qa.cleartrip.com': 'QA',
  'https://bh.cleartrip.com': 'BH',
  'https://kw.cleartrip.com': 'KW',
  'https://www.cleartrip.sa': 'SA',
  'https://qa2.cleartrip.sa': 'SA',
  'https://qa2new.cleartrip.sa': 'SA',
  'https://me.cleartrip.com': 'ME',
  'https://qa2me.cleartrip.com': 'ME',
  'https://www.cleartrip.eu': 'EU',
  'https://www.cleartrip.pl': 'PL',
  'https://www.cleartrip.co.za': 'ZA',
  'https://qa2kw.cleartrip.com': 'KW',
  'https://qa2om.cleartrip.com': 'OM',
  'https://qa2bh.cleartrip.com': 'BH',
  'https://qa2qa.cleartrip.com': 'QA',
  'https://www.cleartrip.me': 'ME',
  'https://www.cleartrip.ae': 'AE',
  'https://qa2.cleartrip.ae': 'AE',
  'https://me.cleartrip.ae': 'AE',
  'https://uat.cleartrip.ae': 'AE',
  'https://www.cleartrip.sa': 'SA',
  'https://qa2.cleartrip.sa': 'SA',
  'https://me.cleartrip.sa': 'SA',
  'https://uat.cleartrip.sa': 'SA',
  'https://bh.cleartrip.com': 'BH',
  'https://bh.cleartrip.sa': 'BH',
  'https://uat.cleartrip.bh': 'BH',
  'https://www.cleartrip.bh': 'BH',
  'https://om.cleartrip.com': 'OM',
  'https://om.cleartrip.sa': 'OM',
  'https://uat.cleartrip.om': 'OM',
  'https://www.cleartrip.om': 'OM',
  'https://kw.cleartrip.com': 'KW',
  'https://kw.cleartrip.sa': 'KW',
  'https://uat.cleartrip.com.kw': 'KW',
  'https://www.cleartrip.kw': 'KW',
  'https://qa.cleartrip.com': 'QA',
  'https://qar.cleartrip.sa': 'QA',
  'https://uat.cleartrip.qa': 'QA',
  'https://www.cleartrip.qa': 'QA'
}